import {ValueObject} from '@s-ui/domain'

export class NewsTagValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.tag
   */

  getTag = () => this._tag
}
